import type { IUserSummary } from '../types/global/helper';

/** Parse `/users/search` body from `api()` (axios `response.data`). */
export function parseUserSearchResponse(response: unknown): IUserSummary[] {
    if (response == null) return [];
    if (Array.isArray(response)) return response as IUserSummary[];

    const root = response as Record<string, unknown>;
    const nested = root.data;
    if (Array.isArray(nested)) return nested as IUserSummary[];

    if (nested && typeof nested === 'object') {
        const result = (nested as Record<string, unknown>).result;
        if (Array.isArray(result)) return result as IUserSummary[];
    }

    if (Array.isArray(root.result)) return root.result as IUserSummary[];
    return [];
}

/** @deprecated Prefer `adminSearchUsers` from redux/adminUserSearch/actions via useDispatchPromise. */
export { adminSearchUsers } from '../redux/adminUserSearch/actions';
